"use client";

import { EmailCaptureForm } from "@/components/forms/email-capture-form";
import { useApplyNowSubmit } from "@/hooks/use-apply-now-submit";
import type { ApplyNowEligibilityFields } from "@/lib/apply-now/submit-apply-now";

export interface ApplyNowEmailCaptureProps {
  emailPlaceholder: string;
  applyLabel: string;
  sendingLabel?: string;
  eligibility?: ApplyNowEligibilityFields;
  /** When false, submits to HubSpot without redirecting to signup. */
  redirectToSignup?: boolean;
  /**
   * Let visitors continue with the field empty — skips the HubSpot submit and
   * sends them to signup without an email prefill.
   */
  allowEmptyEmail?: boolean;
  onSubmitted?: () => void;
  className?: string;
  inputClassName?: string;
  formClassName?: string;
  /** hero-form uses the shared email capture pill button layout (Figma 4074:23618). */
  buttonLayout?: "hero-form" | "default";
  hideArrowOnMobile?: boolean;
  disabled?: boolean;
  id?: string;
  prefillEmail?: string;
  /** Delay before signup redirect (eligible path only). */
  redirectDelayMs?: number;
}

export function ApplyNowEmailCapture({
  emailPlaceholder,
  applyLabel,
  sendingLabel = "Sending…",
  eligibility,
  redirectToSignup = true,
  allowEmptyEmail = false,
  onSubmitted,
  className,
  inputClassName,
  formClassName,
  buttonLayout = "default",
  hideArrowOnMobile = false,
  disabled = false,
  id = "apply-now-email",
  prefillEmail = "",
  redirectDelayMs,
}: ApplyNowEmailCaptureProps) {
  const { submit, isSubmitting } = useApplyNowSubmit({
    eligibility,
    redirectToSignup,
    allowEmptyEmail,
    onSuccess: onSubmitted,
    redirectDelayMs,
  });

  return (
    <EmailCaptureForm
      id={id}
      emailPlaceholder={emailPlaceholder}
      submitLabel={applyLabel}
      sendingLabel={sendingLabel}
      onSubmitEmail={submit}
      isSubmitting={isSubmitting}
      allowEmpty={allowEmptyEmail}
      className={className}
      inputClassName={inputClassName}
      formClassName={formClassName}
      buttonLayout={buttonLayout}
      hideArrowOnMobile={hideArrowOnMobile}
      disabled={disabled}
      prefillEmail={prefillEmail}
    />
  );
}
